import { render } from "./RdeMenu.vue?vue&type=template&id=f6521dd8"
import script from "./RdeMenu.vue?vue&type=script&lang=js"
export * from "./RdeMenu.vue?vue&type=script&lang=js"

import "./RdeMenu.vue?vue&type=style&index=0&id=f6521dd8&lang=css"

import exportComponent from "/Users/tizetimoyosore/Developer/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__